import { Drug } from "@/api/types";

export const getNormalizedDrugQuantity = (
  drugConfiguration: Drug["configurations"][number] | undefined,
  selectedQuantity: string,
): number => {
  const rawAmount = parseFloat(selectedQuantity);

  if (!drugConfiguration) {
    return rawAmount;
  }

  return rawAmount * (drugConfiguration.quantity_multiplier ?? 1);
};
